type LocalTableDataProps = {
  data: any[];
  limit: number;
  offset: number;
  search?: string;
  parser?: (data: any) => any;
};

type LocalTableDataReturn = {
  paginatedData: any[];
  total: number;
  data: any[];
};

export const useLocalTableData = (
  props: LocalTableDataProps
): LocalTableDataReturn => {
  const { data, limit, offset, search, parser = (data: any) => data } = props;
  if (search) {
    const filteredData = data.filter((item) =>
      Object.values(item).some((value) =>
        String(value).toLowerCase().includes(search.toLowerCase())
      )
    );
    return {
      paginatedData: filteredData.slice(offset, offset + limit).map(parser),
      total: filteredData.length,
      data: filteredData,
    };
  }
  return {
    paginatedData: data.slice(offset, offset + limit).map(parser),
    total: data.length,
    data: data.map(parser),
  };
};
